import { styled } from '@mui/system';
import { TextField } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { IconArrowDropDown } from 'assets/icons';

const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: 'inherit',
  width: '100%',
  '& .MuiTextField-root': {
    marginRight: 0
  }
}));

const TextFieldSelectRoot = styled(TextField)({
  "& .MuiInputLabel-root": {
    lineHeight: '1.8em',
    color: 'var(--mui-palette-primary-main)'
  },
  "& .MuiInputBase-root": {
    color: 'var(--mui-palette-secondary-textIconColor)',
    "& svg": {
      fill: 'var(--mui-palette-secondary-textIconColor)'
    }
  },
  '& .MuiSelect-select': {
    position: 'absolute',
    width: '-webkit-fill-available',
    paddingLeft: '12px',
    '& > div': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0
  },
  '&.selected .MuiSelect-select': {
    color: 'var(--mui-palette-primary-textColor)'
  }
});


const TextFieldSelect = (props) => {
  return (
    <FormControlLabelStyled
      control={
        <TextFieldSelectRoot
          select
          fullWidth
          size='small'
          autoComplete='off'
          {...props} 
          SelectProps={{IconComponent: IconArrowDropDown,...props.SelectProps}}
        />
      }
    />
  );
}

export default TextFieldSelect;
